import React from "react";

function About(props) {
  if (props.data) {
    var pid = props.data.pid;
    var description = props.data.description;
    var stacks = props.data.stack;
  }

  return (
    <section id="about" className="about-mf sect-pt4 route">
      <div className="container">
        <div className="row">
          <div className="col-sm-12">
            <div className="box-shadow-full mob-space">
              <div className="row">
                <div className="about-me pt-4 pt-md-0">
                  <div className="title-box-2">
                    <h5 className="title-left">About Me</h5>
                  </div>
                  <p className="lead" key={pid}>
                    {description}
                  </p>
                </div>
                <div className="tech-stacks mt-3">
                  <p className="lead font-weight-bold">My Technology Stacks:</p>
                  <div className="stack-icons d-flex flex-wrap justify-content-center">
                    {stacks?.map((stack) => {
                      return (
                        <div key={stack.name} className="stack-box">
                          <img className="stack-icon" src={stack.url} alt="" />
                          <p className="text-center font-weight-bold">
                            {stack.name}
                          </p>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
